module.exports = __webpack_public_path__ + "img/Shopping-cart.36ac3e41.svg";